export default __webpack_public_path__ + "static/media/partlyCloud.66b938b2.svg";